import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import { useField } from "formik";

interface IFormikPreviewAutoCompleteFieldProps {
  name: string;
  labelledById: string;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  placeholder: string;
}
export const FormikPreviewAutoCompleteField: React.FC<
  IFormikPreviewAutoCompleteFieldProps
> = ({ name, placeholder, labelledById, onKeyDown }) => {
  const [field, meta, helpers] = useField<string>({
    name,
  });

  const setValue = (value: string[] | null) => {
    value && helpers.setValue(JSON.stringify(value));
  };
  const value = field.value ? (JSON.parse(field.value) as string[]) : [];
  return (
    <Autocomplete
      multiple
      freeSolo
      data-cy={`autocomplete-${labelledById}`}
      value={value}
      onChange={(e, value) => setValue(value as string[])}
      options={[]}
      clearOnBlur
      renderInput={(params) => (
        <TextField
          {...params}
          inputProps={{ ...params.inputProps, autoComplete: "off" }}
          variant="outlined"
          size="small"
          placeholder={placeholder}
          aria-labelledby={labelledById}
          onKeyDown={onKeyDown}
          error={meta.touched && meta.error ? true : false}
          helperText={meta.error}
        />
      )}
    />
  );
};
